export function canAddWorkoutSet({ readOnly, workoutEditable, isOngoing, isTemplateMode }) {
  if (readOnly) return false;
  return Boolean((workoutEditable && isOngoing) || isTemplateMode);
}
